import { Button, Form } from "rsuite";

import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";
import { ApiAuth } from "../../core/apis/auth";
import { showErrorToast, showSuccessToast } from "../generic/toast.component";

import { ResetPasswordForm } from "./resetPasswordForm.component";
import {
  ResetPasswordFormType,
  ResetPasswordDefaultValues,
  ResetPasswordFormSchema,
} from "../../models/forms/resetPasswordForm";

export const ResetPassword = () => {
  const [formValue, setFormValue] = useState<ResetPasswordFormType>(
    ResetPasswordDefaultValues
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchParams, _] = useSearchParams();
  const token = searchParams.get("token") || "";
  const accountId = searchParams.get("accountId");
  const navigate = useNavigate();

  const handleSave = async (checked: boolean) => {
    if (!checked) return;
    setIsLoading(true);
    if (formValue.NewPassword != formValue.ConfirmNewPassword) {
      showErrorToast("Password & ConfirmPassword not matched!");
      setIsLoading(false);
      return;
    }
    var resetPasswordData: ResetPasswordFormType = {
      accountId: accountId || "",
      NewPassword: formValue.NewPassword,
      ConfirmNewPassword: formValue.ConfirmNewPassword,
      Token: token.replaceAll(" ", "+"),
    };
    try {
      await ApiAuth.resetPassword(resetPasswordData);
      navigate(AppRoutesUI.Auth.Login.Path());
      showSuccessToast("Password reset Successfully");
    } catch (e: any) {
      showErrorToast(e.response?.data?.Message || e.message);
    }
    setFormValue(ResetPasswordDefaultValues);
    setIsLoading(false);
  };

  return (
    <div className="d-flex flex-column px-xl-5 m-xl-4 px-sm-0">
      <Form
        formValue={formValue}
        onChange={setFormValue}
        model={ResetPasswordFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <ResetPasswordForm formValue={formValue} />
        <div className="d-flex justify-content-end align-items-center mb-3 mt-4">
          <Button
            size="sm"
            appearance="primary"
            loading={isLoading}
            type="submit"
            className="form-cancel-buttons fw-bold px-3"
          >
            Create password and Sign In
          </Button>
        </div>
      </Form>
    </div>
  );
};
